<div class="az-consulting-info__field">
  <span class="az-consulting-info__label">求人種別</span>
  <span class="az-consulting-info__value">{{ getJobCategoryLabel(consultingInfo.selectedJobCategory) }}</span>
</div>

<div class="az-consulting-info__field" *ngIf="showMiddlePermissionResult">
  <span class="az-consulting-info__label">企画相談結果</span>
  <span
    class="az-consulting-info__value"
    [class.az-consulting-info__value--accepted]="consultingInfo.middlePermissionFlg === 1"
    [class.az-consulting-info__value--rejected]="consultingInfo.middlePermissionFlg === 0"
  >{{ getMiddlePermissionLabel(consultingInfo.middlePermissionFlg) }}</span>
</div>

<div class="az-consulting-info__field az-consulting-info__field--column">
  <span class="az-consulting-info__label">連絡事項</span>
  <textarea class="az-consulting-info__textarea" [value]="consultingInfo.contactMessage" disabled></textarea>
</div>

<h3 class="az-consulting-info__section-title">相談内容</h3>

<div class="az-consulting-info__items">
  <div class="az-consulting-info__item" *ngFor="let key of consultingItemKeys">
    <ng-container *ngIf="getConsultingItem(key) as item">
      <div class="az-consulting-info__target">
        <div
          class="az-consulting-info__alert"
          [class.az-consulting-info__alert--error]="item.errorMessage && item.errorType === 'error'"
          [class.az-consulting-info__alert--warning]="item.errorMessage && item.errorType === 'warning'"
        >
          {{ item.errorMessage }}
        </div>
        <div class="az-consulting-info__field-info">
          <table class="az-consulting-info__table" *ngIf="item.requiredValueLabel || item.actualValueLabel; else normalItem">
            <tr>
              <th>項目</th>
              <td>{{ item.label }}</td>
            </tr>
            <tr>
              <th>{{ item.requiredValueLabel }}</th>
              <td>{{ item.requiredValue != null ? (item.requiredValue | number:'1.0-2') + item.unit : '-' }}</td>
            </tr>
            <tr>
              <th>{{ item.actualValueLabel }}</th>
              <td>{{ item.actualValue != null ? (item.actualValue | number:'1.0-2') + item.unit : '計算エラー' }}</td>
            </tr>
          </table>
          <ng-template #normalItem>
            <table class="az-consulting-info__table">
              <tr>
                <th>{{ item.label }}</th>
                <td>{{ item.value || '（未入力）' }}</td>
              </tr>
            </table>
          </ng-template>
        </div>
      </div>
      <div class="az-consulting-info__content">
        <textarea
          class="az-consulting-info__textarea"
          [value]="item.consultingContent"
          disabled
        ></textarea>
      </div>
    </ng-container>
  </div>
</div>

<p class="az-consulting-info__empty" *ngIf="!consultingItemKeys.length">
  相談項目なし
</p>

<div
  class="az-consulting-info__field az-consulting-info__field--column az-consulting-info__field--description"
  *ngIf="showDescription"
>
  <span class="az-consulting-info__label">備考</span>
  <textarea
    *ngIf="editableDescription; else readonlyDescription"
    class="az-consulting-info__textarea"
    [ngModel]="editedDescription"
    (ngModelChange)="onDescriptionInput($event)"
    placeholder="備考を入力してください"
  ></textarea>
  <ng-template #readonlyDescription>
    <textarea class="az-consulting-info__textarea" [value]="consultingInfo.resultDescription" disabled></textarea>
  </ng-template>
</div>
